import emoji from '@/utils/emoji'
import { dateFormat } from '@/utils/function'
export default {
  methods: {
    customEmoji(value) {
      return `<img src="/static/emoji/${value}" style="width:20px"/>`
    },

    renderTime(time) {
      time = parseInt(time)
      const nowStr = new Date()
      const localStr = time ? new Date(time) : nowStr
      const localFormat = dateFormat(localStr, 'mm-dd HH:MM A')
      return localFormat
    },

    renderTxt(txt = '') {
      let rnTxt = []
      let match = null
      const regex = /(\[.*?\])/g
      let start = 0
      let index = 0
      while ((match = regex.exec(txt))) {
        index = match.index
        if (index > start) {
          rnTxt.push(txt.substring(start, index))
        }
        if (match[1] in emoji.obj) {
          const v = emoji.obj[match[1]]
          rnTxt.push(this.customEmoji(v))
        } else {
          rnTxt.push(match[1])
        }
        start = index + match[1].length
      }
      rnTxt.push(txt.substring(start, txt.length))

      return rnTxt.toString().replace(/,/g, '')
    },

    readablizeBytes(value) {
      let s = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB']
      let e = Math.floor(Math.log(value) / Math.log(1024))
      return (value / Math.pow(1024, Math.floor(e))).toFixed(2) + ' ' + s[e]
    },

    isReceivedMsg(item) {
      // eslint-disable-next-line no-prototype-builtins
      if (item.hasOwnProperty('bySelf')) {
        return !item.bySelf
      }
  
      if (item.from.toUpperCase() === this.receivingUser) {
        return true
      }
    },

    chatMsgEmpty(item) {
        let data = item.msg || item.data
        data = data.replace(/(\[.*?\])/g, '')
        
        if (!data) return true
        return false
    }
  }
}